export default __webpack_public_path__ + "static/media/HUD-Effects-Camera Dust.6aca1efe.jpg";